import { SocieteLinkedService } from './societe-linked.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompModel } from 'src/app/shared/models/societe-linked/comp.model';
import { APICONSTANTS } from '../../constants/api-constants';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class CompService extends SocieteLinkedService<CompModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTECOMP, hostnameService);
  }

  getFromNa(id: number): Observable<CompModel[]> {
    return this.http.get<CompModel>(
      APICONSTANTS.URLAPI.value + this.route + 'GetFromNa/' + id)
      .pipe(catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }
  getFromNaAndSociete(idSociete: number, id: number): Observable<CompModel[]> {
    return this.http.get<CompModel>(
      APICONSTANTS.URLAPI.value + this.route + 'getFromNaAndSociete?id=' + id + '&idSociete=' + idSociete)
      .pipe(catchError(err => this.requestCatchError(err, 'L\'enregistrement')));
  }
}
